(function() {
  var BaseHandler, BaseOutput, DetailOutput,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DetailOutput = App.loadClass("core::reports/DetailOutput");

  BaseOutput = App.loadClass("core::reports/BaseOutput");

  BaseHandler = App.loadClass("core::reports/BaseHandler");

  exports.Reports_Competitors_SubHandler = (function(superClass) {
    extend(Reports_Competitors_SubHandler, superClass);

    function Reports_Competitors_SubHandler() {
      return Reports_Competitors_SubHandler.__super__.constructor.apply(this, arguments);
    }

    Reports_Competitors_SubHandler.prototype.init = function() {
      this.layoutSelector = "#reports_competitors_tab";
      this.excelUrl = 'backend/portal/reports/competitors/excel';
      this.filterUrl = 'backend/portal/reports/competitors/filters';
      return this.initFilters();
    };

    Reports_Competitors_SubHandler.prototype.initFilters = function() {
      this.resetFilters();
      this.parent.filters.importGroup({
        name: "Competitors Filters",
        filters: [
          {
            name: 'account_types',
            display_name: 'Account Type',
            "class": 'dropup'
          }, {
            name: 'competitors',
            display_name: 'Competitors',
            "class": 'dropup'
          }, {
            name: 'methods',
            display_name: 'Contact Method',
            "class": 'dropup',
            control_type: 'single_dropdown',
            deletable: false,
            values: [
              {
                key: 'Email',
                value: 'Email + TouchPoint'
              }, {
                key: 'SMS',
                value: 'SMS + TouchPoint'
              }, {
                key: 'TouchPoint',
                value: 'TouchPoint'
              }
            ],
            selected_values: [
              {
                key: 'TouchPoint',
                value: 'TouchPoint'
              }
            ]
          }, {
            name: 'output_type',
            display_name: 'Output Type',
            control_type: 'option',
            deletable: false,
            values: [
              {
                key: 'detail',
                value: 'Detail'
              }, {
                key: 'summary',
                value: 'Summary'
              }
            ],
            selected_values: [
              {
                key: 'detail',
                value: 'Detail'
              }
            ]
          }
        ]
      });
      this.parent.filters.assignGroupName("Competitors Filters", "");
      this.parent.filters.findInGroup('fields').disableFilter();
      this.parent.filters.findInGroup('farms').disableFilter();
      this.parent.filters.moveFilter('owners', "Competitors Filters", 'output_type');
      this.parent.filters.findInGroup('owners')["class"]('dropup');
      this.parent.dialog.find('.email-btn').show();
      this.parent.dialog.delegate('.email-btn', 'click', (function(_this) {
        return function() {
          return _this.goToCommunicatePage();
        };
      })(this));
      return this.setDefaultsAndRun();
    };

    Reports_Competitors_SubHandler.prototype.goToCommunicatePage = function() {
      var communicate_handler, ignoreFilters, primary_nav;
      this.parent.dialog.empty();
      primary_nav = $(document).find('#nav_primary_links');
      primary_nav.find('li.active').removeClass('active');
      primary_nav.find("a[data-page-name='communicate']").closest('li').addClass('active');
      communicate_handler = this.createSubHandler('portal::handlers/communicate/Communicate_Handler');
      if (communicate_handler) {
        ignoreFilters = ['output_type'];
        return communicate_handler.init(this.filterUrl, this.parent.filters.exportStructure(ignoreFilters));
      }
    };

    Reports_Competitors_SubHandler.prototype.destroy = function() {
      this.parent.filters.findInGroup('fields').enableFilter();
      this.parent.filters.findInGroup('farms').enableFilter();
      this.parent.filters.moveFilter('owners', "Operation Filters", 'farms');
      this.parent.filters.findInGroup('owners')["class"]('dropdown');
      this.parent.filters.removeGroup("Competitors Filters");
      this.parent.dialog.find('.email-btn').hide();
      return Reports_Competitors_SubHandler.__super__.destroy.call(this);
    };

    Reports_Competitors_SubHandler.prototype.beforeApply = function() {
      var filters;
      filters = this.parent.filters.jsonize();
      if (filters.filters.output_type[0].key === 'detail') {
        this.layoutUrl = 'backend/portal/reports/competitors/table/detail';
        this.printUrl = 'backend/portal/reports/competitors/print/detail';
        return this.currentOutput = new DetailOutput(this, this.parent, 600, {
          sAjaxSource: 'backend/portal/reports/competitors/output/detail'
        });
      } else {
        this.layoutUrl = 'backend/portal/reports/competitors/output/summary';
        this.printUrl = 'backend/portal/reports/competitors/print/summary';
        return this.currentOutput = new BaseOutput(this, this.parent);
      }
    };

    return Reports_Competitors_SubHandler;

  })(BaseHandler);

}).call(this);
